import React, { FC, PropsWithChildren, useRef } from 'react';

import { IcRightIcon } from '@gem/icons';

import { IconView } from '../../IconView/IconView';
import { usePopover } from '../../Popover/usePopover';
import { PopoverMenu } from '../PopoverMenu';
import { IPopoverMenuItem } from '../PopoverMenu.types';
import { IPopoverMenuItemProps, PopoverMenuItem } from '../PopoverMenuItem/PopoverMenuItem';
import {
  SUB_MENU_MOUSE_OUT_TIMEOUT,
  SUB_MENU_POPOVER_MODIFIERS,
  SUB_MENU_POPOVER_PLACEMENT,
} from './PopoverSubMenu.constants';
import styles from './PopoverSubMenu.m.css';

interface IPopoverSubMenuProps extends IPopoverMenuItemProps {
  menuItems: IPopoverMenuItem[];
}

export const PopoverSubMenu: FC<PropsWithChildren<IPopoverSubMenuProps>> = ({
  menuItems,
  children,
  theme,
  item,
  onClose,
  className,
  size,
}) => {
  const referenceRef = useRef<HTMLElement | null>(null);
  const popover = usePopover({ mouseOutTimeout: SUB_MENU_MOUSE_OUT_TIMEOUT });

  if (menuItems.length === 1) {
    return (
      <PopoverMenuItem
        theme={theme}
        className={className}
        item={menuItems[0]}
        icon={item.icon}
        onClose={onClose}
        size={size}
      >
        {children}
      </PopoverMenuItem>
    );
  }

  const onSubMenuClose = (): void => {
    onClose?.();
    popover.close();
  };

  return (
    <PopoverMenuItem
      theme={theme}
      className={className}
      isSelected={popover.isOpened}
      ref={referenceRef}
      item={item}
      onClick={popover.open}
      onMouseEnter={popover.mouseOver}
      onMouseLeave={popover.mouseOut}
      suffix={
        <IconView
          Icon={IcRightIcon}
          className={styles.rightIcon}
          theme="inherit"
        />
      }
    >
      {children}

      <PopoverMenu
        menuClassName={className}
        theme={theme}
        isOpened={popover.isOpened}
        menuItems={menuItems}
        reference={referenceRef.current}
        placement={SUB_MENU_POPOVER_PLACEMENT}
        modifiers={SUB_MENU_POPOVER_MODIFIERS}
        onClose={onSubMenuClose}
      />
    </PopoverMenuItem>
  );
};
